export default {
  GET_CUSTOMER_KUSPIT_POSITION_DETAILS_QUERY: Symbol.for('GET_CUSTOMER_KUSPIT_POSITION_DETAILS_QUERY'),
  CUSTOMER_KUSPIT_POSITION_DETAILS_REPOSITORY: Symbol.for('CUSTOMER_KUSPIT_POSITION_DETAILS_REPOSITORY'),
  GET_CUSTOMER_KUSPIT_POSITION_QUERY: Symbol.for('GET_CUSTOMER_KUSPIT_POSITION_QUERY'),
  CUSTOMER_KUSPIT_POSITION_REPOSITORY: Symbol.for('CUSTOMER_KUSPIT_POSITION_REPOSITORY'),
  CUSTOMER_KUSPIT_POSITION_STATE_MANAGER: Symbol.for('CUSTOMER_KUSPIT_POSITION_STATE_MANAGER'),
};
